import { Controller, useFormContext } from "react-hook-form";

import type { PropTypes } from "./select-categories-v2";
import { SelectCategoriesV2 } from "./select-categories-v2";

// ----------------------------------------------------------------------

type Props = Omit<PropTypes, "value" | "onChange"> & {
	name: string;
};

export const RHFSelectCategoriesV2 = ({
	name,
	placeholder,
	...other
}: Props) => {
	const { control, setValue } = useFormContext();

	return (
		<Controller
			name={name}
			control={control}
			render={({ field, fieldState: { error } }) => {
				// eslint-disable-next-line @typescript-eslint/no-unused-vars
				const { ref, ...rest } = field;

				return (
					<SelectCategoriesV2
						{...rest}
						{...other}
						value={field.value}
						placeholder={
							field.value?.length > 0
								? ""
								: placeholder === undefined
									? "Chuyên gia trong lĩnh vực"
									: placeholder
						}
						onChange={(newValue) => {
							setValue(name, newValue, {
								shouldValidate: true,
								shouldDirty: true,
							})
						}}
						error={error as never}
					/>
				);
			}}
		/>
	);
};
